// Libraries
import { VictoryLabelStyleObject } from 'victory';
// Utils
import { colors } from '@themeFoundations/colors';
// Types
import { MaxCharsPerLineMap } from './TickLabel.types';
import { LabelBreakpointsStyles } from '@molecules/index';

export const tickLabelStyles: VictoryLabelStyleObject = {
  fontSize: 15,
  fill: colors.text.faded,
};

export const tickLabelStylesMap: LabelBreakpointsStyles = {
  base: {
    ...tickLabelStyles,
  },
  sm: {
    ...tickLabelStyles,
    fontSize: 10,
  },
  '2xl': {
    ...tickLabelStyles,
    fontSize: 7,
  },
};

export const maxCharsPerLineMap: MaxCharsPerLineMap = {
  base: 6,
  sm: 12,
};
